import { GetSearchCandidateProfileQueryQuery } from 'generated-graphql/hooks/apollo-hooks';
import { extractQueryGetItem } from 'core/utils/apollo/extractGetItem';
import { CandidateFilterNode } from 'modules/candidate-profile/types/CandidateSearchFilter';

/**
 * `SearchCandidateProfileQuery.filter` is AWSJSON, so it arrives as a string:
 * the tree the search actually ran, recruiter's filters and the agent's
 * combined. Null for searches that predate the sourcing endpoint.
 */
export const extractStoredFilterTree = (
  queryData: GetSearchCandidateProfileQueryQuery | undefined
): CandidateFilterNode | null => {
  const stored = extractQueryGetItem(queryData)?.filter;
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);
    // A tree is an object. Anything else was not written by this service, and
    // reopening a search must not fail on it.
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    console.warn('Reopened search: stored filter tree is not valid JSON.');
    return null;
  }
};
